module.exports = __webpack_public_path__ + "static/contributors-6b0cbdfa111bd0ea291cca734dc55074.png";